/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Senddrafts_Selectall3Inputs */

const en_coinvestments_senddrafts_selectall3 = /** @type {(inputs: Coinvestments_Senddrafts_Selectall3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select all drafts`)
};

/**
* | output |
* | --- |
* | "Select all drafts" |
*
* @param {Coinvestments_Senddrafts_Selectall3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_selectall3 = /** @type {((inputs?: Coinvestments_Senddrafts_Selectall3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Selectall3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_selectall3(inputs)
});
export { coinvestments_senddrafts_selectall3 as "coInvestments_sendDrafts_selectAll" }